var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoBlack = function SvgLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.867 4.966c.337-1.21 1.528-1.897 2.66-1.537 1.13.361 1.775 1.633 1.437 2.844l-2.444 8.76c-.337 1.21-1.528 1.898-2.66 1.538-1.13-.361-1.774-1.633-1.437-2.844l2.444-8.76ZM12.48 4.966c.337-1.209 1.528-1.897 2.66-1.537 1.13.361 1.774 1.633 1.437 2.844l-2.444 8.76c-.337 1.21-1.528 1.898-2.66 1.538-1.131-.361-1.775-1.633-1.437-2.844l2.444-8.76Z",
    fill: "#222"
  })));
};

export default SvgLogoBlack;